const MERCHANT_PROFILE_READ = "MERCHANT_PROFILE_READ";
const ITEMS_READ = "ITEMS_READ";
const MERCHANT_PROFILE_WRITE = "MERCHANT_PROFILE_WRITE";
const PAYMENTS_READ = "PAYMENTS_READ";
const PAYMENTS_WRITE = "PAYMENTS_WRITE";
const CUSTOMERS_READ = "CUSTOMERS_READ";
const CUSTOMERS_WRITE = "CUSTOMERS_WRITE";
const ORDERS_READ = "ORDERS_READ";
const ORDERS_WRITE = "ORDERS_WRITE";
const PAYMENTS_WRITE_ADDITIONAL_RECIPIENTS = "PAYMENTS_WRITE_ADDITIONAL_RECIPIENTS";

export const squareConfig = {
    domains: {
        "dev": "squareupsandbox",
        "staging": "squareupsandbox",
        "prod": "squareup",
    },
    clientIDs: {
        "dev": "sandbox-sq0idb-H7O0i8uOgd4bPmVpSedJkg",
        "staging": "sandbox-sq0idb-H7O0i8uOgd4bPmVpSedJkg",
        "prod": "sq0idp-EYm1ewdua57GbToKLys75g"
    },
    scopes: {
        "dev": [MERCHANT_PROFILE_READ, ITEMS_READ, MERCHANT_PROFILE_WRITE, PAYMENTS_READ, PAYMENTS_WRITE, CUSTOMERS_READ, CUSTOMERS_WRITE, CUSTOMERS_READ, ORDERS_WRITE, ORDERS_READ, PAYMENTS_WRITE_ADDITIONAL_RECIPIENTS],
        "staging": [MERCHANT_PROFILE_READ, ITEMS_READ, MERCHANT_PROFILE_WRITE, PAYMENTS_READ, PAYMENTS_WRITE, CUSTOMERS_READ, CUSTOMERS_WRITE, CUSTOMERS_READ, ORDERS_WRITE, ORDERS_READ, PAYMENTS_WRITE_ADDITIONAL_RECIPIENTS],
        "prod": [MERCHANT_PROFILE_READ, ITEMS_READ, MERCHANT_PROFILE_WRITE, PAYMENTS_READ, PAYMENTS_WRITE, CUSTOMERS_READ, CUSTOMERS_WRITE, CUSTOMERS_READ, ORDERS_WRITE, ORDERS_READ, PAYMENTS_WRITE_ADDITIONAL_RECIPIENTS]
    },
    sessions: {
        "dev": true,
        "staging": true,
        "prod": false,
    },
    cookieUrls: {
        "dev": "",
        "staging": "",
        "prod": "/t/f_partnerships/d_partnerpage/p_yoello/c_general/o_none/u_oauth?route="
    }

}